import { render } from "./DinnerModal.vue?vue&type=template&id=248371f7&ts=true"
import script from "./DinnerModal.vue?vue&type=script&lang=ts"
export * from "./DinnerModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__